import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import Document from "../../../../common/document/document.component.jsx"
import Icon from "../../../../common/icon/icon.component.jsx"
import {FormattedMessage} from "react-intl";
import SectionWrapper from "../../sectionwrapper.component.jsx";

class ProjectFilesContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function(){},
            id: this.props.id || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            id: nextProps.id || '',
        })
    }

    render() {
        if (!this.state.variables) {
            return <div />
        }
        const hide = this.state.editable ? '' : 'd-none'

        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <div className="col-12 py-2">
                    <div className="row">
                        {this.state.variables.project.files.length > 0 ? this.state.variables.project.files.map((doc, i) => {
                            return <div key={i} className="col-xs-6 col-sm-6 col-md-3 col-lg-2">
                                <Document
                                    name={doc.attributes.name}
                                    link={doc.attributes.filePublicUrl}
                                    extension={doc.attributes.extension}
                                    size={'large'}
                                />
                            </div>
                        }) : <div className={'col-12 ' + hide}>
                            <p className={"section-empty-message m-0 text-left"}>
                                <FormattedMessage
                                    id="templates.sections.content_types.project_files.name"
                                    defaultMessage="Project files"
                                />
                            </p>
                            <p className={"section-empty-message"}>
                                <Icon value={"file-pdf"} />
                                <small className={"ml-2"}>
                                    <FormattedMessage
                                        id="templates.sections.project_files.empty_message"
                                        defaultMessage="There is no file in this project"
                                    />
                                </small>
                            </p>

                        </div>}
                    </div>
                </div>
            </SectionWrapper>
        );
    }
}

export default ProjectFilesContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/project-files/section.component.jsx